import React from 'react';
import styled from 'react-emotion';

const Container = styled.div`
  width: 100%;
  padding: 35px 0 22px 0;
  page-break-after: always;
`;

const Source = styled.div`
  text-align: center;
  font-size: 26px;
  color: #22a7f2;
  line-height: 1.0;
`;

const Notice = styled.div`
  width: 100%;
  font-size: 23px;
  text-align: center;
  line-height: 1.0;
  color: #999;
  margin-top: 17px;
`;

const DoctorAnnouncement = () => (
  <Container>
    <Source>根据您当前的健康状态定制了个性化养生方案</Source>
    <Notice>（此报告仅作参考，如有不适请及时就医）</Notice>
  </Container>
);

export default DoctorAnnouncement;



// WEBPACK FOOTER //
// ./src/components/doctor-announcement.jsx